import { DataTableColumnHeader } from 'components/ui/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import {
  DataTableActions,
  IDataTableAction,
} from 'components/ui/DataTableActions';
import { IAiUser } from 'interfaces/settings/AiUser/AiUser';
import { usePermissions } from 'hooks';

interface IColumnProps {
  deleteAiUser: (aiUser: IAiUser) => void;
}

export function useColumns({ deleteAiUser }: IColumnProps) {
  const { checkUserPermission } = usePermissions();
  const columns: ColumnDef<IAiUser>[] = [
    {
      id: 'Id',
      accessorKey: 'id',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Id" />
      ),
      cell: ({ row }) => {
        return `${row.original.id}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'Nome',
      accessorKey: 'name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Nome" />
      ),
      cell: ({ row }) => {
        return `${row.original.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'Telefone',
      accessorKey: 'phone_number',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Telefone" />
      ),
      cell: ({ row }) => {
        return `${row.original.phone_number}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'Criado em',
      accessorKey: 'created_at',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Criado em" />
      ),
      cell: ({ row }) => {
        return `${new Date(row.original.created_at).toLocaleDateString(
          'pt-BR',
          {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }
        )}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'actions',
      cell: ({ row }) => {
        const actions: IDataTableAction[] = [
          {
            name: 'Editar',
            route: `/settings/ai-user/edit/${row.original.id}`,
            hasPermission: checkUserPermission('editUser'),
          },
          {
            name: 'Excluir',
            action: () => deleteAiUser(row.original),
            hasPermission: checkUserPermission('editUser'),
          },
        ];
        return <DataTableActions actions={actions} />;
      },
    },
  ];

  return { columns };
}
